import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Outlet } from "react-router-dom";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { AdminAuthProvider } from "@/admin/AdminAuthContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import HomePage from "@/pages/Home";
import AboutPage from "@/pages/About";
import ServicesPage from "@/pages/Services";
import SimpPage from "@/pages/Simp";
import IndustriesPage from "@/pages/Industries";
import ProjectsPage from "@/pages/Projects";
import ContactPage from "@/pages/Contact";
import CareersPage from "@/pages/Careers";
import LegalPage from "@/pages/Legal";
import AdminLoginPage from "@/admin/AdminLogin";
import AdminMessagesPage from "@/admin/AdminMessages";
import { Toaster } from "@/components/ui/sonner";
import CookieBanner from "@/components/CookieBanner";
import { useT } from "@/i18n/LanguageContext";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

const PAGE_META = {
  "/": { titleKey: "nav.home" },
  "/about": { titleKey: "nav.about" },
  "/services": { titleKey: "nav.services" },
  "/simp": { titleKey: "nav.simp" },
  "/industries": { titleKey: "nav.industries" },
  "/projects": { titleKey: "nav.projects" },
  "/careers": { titleKey: "nav.careers" },
  "/contact": { titleKey: "nav.contact" },
  "/legal": { titleKey: "nav.legal" },
};

function PageTitle() {
  const { pathname } = useLocation();
  const { t, locale } = useT();
  useEffect(() => {
    const meta = PAGE_META[pathname] || PAGE_META["/"];
    document.title = `${t(meta.titleKey)} — Bigradap Group Technologies`;
    document.documentElement.setAttribute("lang", locale);
  }, [pathname, locale, t]);
  return null;
}

function PublicLayout() {
  return (
    <>
      <Header />
      <Outlet />
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <AdminAuthProvider>
          <BrowserRouter>
            <ScrollToTop />
            <PageTitle />
            <Routes>
              <Route element={<PublicLayout />}>
                <Route path="/" element={<HomePage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/services" element={<ServicesPage />} />
                <Route path="/simp" element={<SimpPage />} />
                <Route path="/industries" element={<IndustriesPage />} />
                <Route path="/projects" element={<ProjectsPage />} />
                <Route path="/careers" element={<CareersPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/legal" element={<LegalPage />} />
              </Route>
              <Route path="/admin" element={<AdminLoginPage />} />
              <Route path="/admin/login" element={<AdminLoginPage />} />
              <Route path="/admin/messages" element={<AdminMessagesPage />} />
              <Route path="*" element={<PublicLayout />}>
                <Route index element={<HomePage />} />
              </Route>
            </Routes>
            <CookieBanner />
            <Toaster position="top-right" theme="dark" />
          </BrowserRouter>
        </AdminAuthProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
